<template>
    <el-form :model="account" label-width="120px" label-position="left" size="small">
        <el-form-item label="First name">
            <el-input v-model="account.first_name" placeholder="First name" />
        </el-form-item>
        <el-form-item label="Last name">
            <el-input v-model="account.last_name" placeholder="Last name" />
        </el-form-item>
        <el-form-item label="Email">
            <el-input v-model="account.email" disabled />
        </el-form-item>
        <el-form-item label="Phone number">
            <el-input v-model="account.phone_number" placeholder="+972 544 123 456" />
        </el-form-item>
        <el-form-item label="Slack username">
            <el-input v-model="account.slack_username" placeholder="@alice" />
        </el-form-item>
        <el-form-item label="First day of week">
            <el-select v-model="account.first_day_of_week">
                <el-option value="sunday" label="Sunday" />
                <el-option value="monday" label="Monday" />
            </el-select>
        </el-form-item>
        <el-form-item label="Timezone">
            <el-select v-model="account.timezone" filterable>
                <el-option v-for="tz in timezones" :key="tz" :value="tz" :label="tz" />
            </el-select>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="save">Save</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
import { tz } from 'moment-timezone';
import { mapActions } from 'vuex';

export default {
    data() {
        return {
            type: 'conversion',
            eventaccount: {},
            showEditDialog: false,
            timezones: tz.names(),
        }
    },
    props: {
        account: Object,
        afterSave: {
            type: Function,
            default: () => {},
        }
    },
    methods: {
        ...mapActions(['getAdmins']),
        async save() {
            try {
                const { id } = this.account;
                await this.$api.put(`/admins/${id}`, this.account);

                this.$message.success('Saved successfully');
                this.afterSave();
            } catch (e) {
                this.$notify.error({
                    title: 'Failed saving changes',
                    message: e.message,
                });
            } finally {
                this.getAdmins();
            }
        }
    },
}
</script>
